export default __webpack_public_path__ + "fonts/ABB-UI-Icons-24x24-22Mco.ttf";